import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { config } from 'src/config/config';

import { RootState } from 'src/config/rootStore';
import { isAuthenticated } from 'src/modules/auth/selectors/authenticationSelectors';

import * as S from './styles';

interface StateProps {
    isLoggedIn: boolean;
}

type Props = StateProps;

const FooterContainer: React.FC<Props> = props => {
    const { t } = useTranslation();

    return (
        <S.FooterOuterWrapper data-testid="appFooter">
            <S.FooterInnerWrapper loggedIn={props.isLoggedIn}>
                <S.FooterInfoWrapper>
                    <div>
                        <a
                            href={`${config.modernHealthURL}/privacy-policy`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <S.FooterText>{t('shared:privacy_policy')}</S.FooterText>
                        </a>
                        <a
                            href={`${config.modernHealthURL}/terms-of-service`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <S.FooterText>{t('shared:terms_of_service')}</S.FooterText>
                        </a>
                        <S.FooterText>
                            ©{new Date().getFullYear()} Modern Health Inc.{' '}
                            {t('shared:all_rights_reserved')}
                        </S.FooterText>
                    </div>
                    <S.FooterRight>
                        <div>
                            <S.FooterText>576 Sacramento Street</S.FooterText>
                            <S.FooterText>San Francisco, CA 94103</S.FooterText>
                            <S.FooterTextAnchor href="mailto:help@joinmodernhealth.com">
                                help@joinmodernhealth.com
                            </S.FooterTextAnchor>
                        </div>
                    </S.FooterRight>
                </S.FooterInfoWrapper>
            </S.FooterInnerWrapper>
        </S.FooterOuterWrapper>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    isLoggedIn: isAuthenticated(state),
});

export const Footer = connect<StateProps>(mapStateToProps)(FooterContainer);
